var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full bg-theme-background",attrs:{"id":"app"}},[_c('div',{staticClass:"h-full flex p-8"},[_c('Sidebar',{staticClass:"mr-10"}),_c('main',{staticClass:"w-full"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }